/**
 * Helpers DOM pour créer et manipuler des éléments facilement.
 */

/**
 * Crée un élément DOM avec options.
 * @param {string} tag
 * @param {{ className?: string, text?: string, html?: string, attrs?: Record<string, string>, events?: Record<string, Function>, children?: (Node|string)[] }} [options]
 * @returns {HTMLElement}
 */
export function createElement(tag, { className, text, html, attrs, events, children } = {}) {
  const el = document.createElement(tag);

  if (className) {
    el.className = className;
  }

  if (text != null) {
    el.textContent = text;
  } else if (html != null) {
    el.innerHTML = html;
  }

  if (attrs) {
    for (const [key, value] of Object.entries(attrs)) {
      if (value != null) {
        el.setAttribute(key, value);
      }
    }
  }

  if (events) {
    for (const [event, handler] of Object.entries(events)) {
      el.addEventListener(event, handler);
    }
  }

  if (children) {
    for (const child of children) {
      if (child == null) continue;
      el.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
    }
  }

  return el;
}

/**
 * Vide un élément de tous ses enfants.
 * @param {HTMLElement} el
 */
export function clearElement(el) {
  while (el.firstChild) {
    el.removeChild(el.firstChild);
  }
}

/**
 * Affiche une notification toast temporaire.
 * @param {string} message
 * @param {number} [duration=3000]
 * @param {'default'|'success'|'error'} [type='default']
 */
export function showToast(message, duration = 3000, type = 'default') {
  const toast = createElement('div', {
    className: `toast${type === 'success' ? ' toast--success' : ''}${type === 'error' ? ' toast--error' : ''}`,
    children: [
      createElement('span', { className: 'toast__message', text: message }),
    ],
  });

  document.body.appendChild(toast);

  // Animation d'entrée
  requestAnimationFrame(() => {
    toast.classList.add('toast--visible');
  });

  setTimeout(() => {
    toast.classList.remove('toast--visible');
    setTimeout(() => toast.remove(), 300);
  }, duration);
}
